// CookieConsent Component - Non-blocking cookie banner
import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('optitrajet_cookie_consent');
    if (!consent) {
      setTimeout(() => setShowBanner(true), 1500);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('optitrajet_cookie_consent', 'accepted');
    setShowBanner(false);
  };

  const handleClose = () => {
    localStorage.setItem('optitrajet_cookie_consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-xl border p-4">
      <button onClick={handleClose} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600">
        <X className="w-4 h-4" />
      </button>
      <p className="text-sm text-gray-600 mb-3 pr-6">
        🍪 Ce site utilise des cookies pour améliorer votre expérience.
      </p>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={handleClose}>
          Refuser
        </Button>
        <Button size="sm" onClick={handleAccept} className="bg-purple-600 hover:bg-purple-700">
          Accepter
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
